'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import invariant from 'react-utils/invariant';
import Immutable from 'immutable';
export default function withPartials(WrappedComponent) {
  var HighOrderWithPartials = /*#__PURE__*/function (_Component) {
    _inherits(HighOrderWithPartials, _Component);

    function HighOrderWithPartials(props) {
      var _this;

      _classCallCheck(this, HighOrderWithPartials);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HighOrderWithPartials).call(this, props));
      _this.partial = _this.partial.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(HighOrderWithPartials, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this._partials = Immutable.Map();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._partials = null;
      }
    }, {
      key: "partial",
      value: function partial(func) {
        var _Immutable$List;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        invariant(typeof func === 'function', '%s.partial: expected `func` to be a function but got `%s`.', getComponentName(WrappedComponent), func);

        var keyList = (_Immutable$List = Immutable.List).of.apply(_Immutable$List, [func].concat(args));

        if (!this._partials.has(keyList)) {
          this._partials = this._partials.set(keyList, function () {
            for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              partialArgs[_key2] = arguments[_key2];
            }

            return func.apply(void 0, args.concat(partialArgs));
          });
        }

        return this._partials.get(keyList);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, Object.assign({}, this.props, {
          partial: this.partial
        }));
      }
    }]);

    return HighOrderWithPartials;
  }(Component);

  return HighOrderWithPartials;
}